exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desc[data-v-2d6fe52a]{align-items:center;display:flex;padding-top:5px;flex-wrap:wrap}a[data-v-2d6fe52a]{color:#fff;display:block;text-decoration:none}", ""]);

// exports
